<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class=" pb-4 text-center">
        <h4>{{'Are you sure do you whant to delete this user'|translate}}</h4>
    </div>

    <div class="d-flex flex-row justify-content-between pb-4">
        <button class="btn_in_color" (click)="deleteUser()">{{ 'DELETE' |
            translate}}</button>
        <button class="btn_without_color" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
</div>